module.exports = __webpack_public_path__ + "resources/img/xamarin.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/xamarin.png
// module id = 1102
// module chunks = 0